<div class="modal-header border-0 pb-0">
  <div>
    <h4 class="modal-title mb-0" style="text-transform: none !important;">
      Usuarios del Grupo
    </h4>
    <small class="text-muted">ID Grupo: {{ grupoId }}</small>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Close click')"></button>
</div>

<div class="modal-body pt-3">
  <div *ngIf="spinner" class="text-center my-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>

  <div *ngIf="!spinner" class="table-responsive">
    <table class="table table-striped table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>Nombre</th>
          <th>Correo Electrónico</th>
          <th class="text-center" style="width: 120px;"> {{ accionLabel ? accionLabel : 'Acceso' }} </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let usuario of currentItems">
          <td>{{ usuario.nombre }}</td>
          <td>{{ usuario.correo }}</td>
          <td class="text-center">
            <div class="form-check form-switch d-inline-block">
              <input 
                class="form-check-input" 
                type="checkbox" 
                [id]="'check-' + usuario.id_usuario_grupo"
                [(ngModel)]="usuario.permitido" 
                [checked]="usuario.permitido"
                (change)="actualizarAccesoUsuario(usuario)">
            </div>
          </td>
        </tr>
        <tr *ngIf="currentItems.length === 0">
          <td colspan="3" class="text-center text-muted py-4">
            No se encontraron usuarios asignados a este grupo.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer border-0 pt-2">
  <button class="btn btn-primary" (click)="clickAgregar()">Agregar</button>
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Cerrar')">
    Cerrar
  </button>
</div>